import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Home';
import SupportPage from './SupportPage';
import QuizMatchPrivacy from './QuizMatchPrivacy';
import MindwarPrivacy from './MindwarPrivacy';
import MindwarSupport from './MindwarSupport';
import ProjectDetail from './components/ProjectDetail';

function App() {
  return (
    <Router>
      <div className="app">
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quizmatchsupport" element={<SupportPage />} />
            <Route path="/quizmatchprivacy" element={<QuizMatchPrivacy />} />
            <Route path="/mindwar_privacy" element={<MindwarPrivacy />} />
            <Route path="/mindwar_support" element={<MindwarSupport />} />
            <Route path="/projects/:projectId" element={<ProjectDetail />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
